const TAG = 'store-util';

export function dispatchAction(action, params) {
  return document.dispatchEvent(
    new CustomEvent('dispatchAction', {
      detail: {
        action: action,
        params,
      },
    })
  );
}
export function commitMutation(mutation, params) {
  document.dispatchEvent(
    new CustomEvent('commitMutation', {
      detail: {
        mutation: mutation,
        params,
      },
    })
  );
}
export function setState({ property, value }) {
  document.dispatchEvent(
    new CustomEvent('commitMutation', {
      detail: {
        mutation: 'setState',
        params: { property, value },
      },
    })
  );
}
export function set({ module, property, value }) {
  document.dispatchEvent(
    new CustomEvent('commitMutation', {
      detail: {
        mutation: 'set',
        params: { module, property, value },
      },
    })
  );
}
